import { TemplateTagsComponent } from './template-tags.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateDirective, TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'

@NgModule({
  declarations: [TemplateTagsComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    TranslateModule,
    ContentEditableModule,
    NgSelectModule,
  ],
  exports: [TemplateTagsComponent],
})
export class TemplateTagsModule {}
